export default (number, currencyCode, currencySymbol, precision = 2) => {
  let maximumFractionDigits = 2;
  const minimumFractionDigits = 2;

  if (!Number.isNaN(parseInt(precision, 10))) {
    maximumFractionDigits = Math.min(precision, 8);
  }

  // We use the browser's configured locale to format the numbers
  const formattedNumber = new Intl.NumberFormat(navigator.language, {
    minimumFractionDigits: Math.min(minimumFractionDigits, maximumFractionDigits),
    maximumFractionDigits,
    numberingSystem: 'latn',
  }).format(Math.abs(number));

  let result = Number(number) < 0 ? '-' : '';

  if (currencySymbol) {
    result = `${result}${currencySymbol}`;
  }

  result = `${result}${formattedNumber}`;

  if (currencyCode) {
    result = `${result} ${currencyCode}`;
  }

  return result;
};
